import React, { useContext } from "react";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { FRAME } from "../../../constants/editor";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import useClippingPicture from "../../../hooks/useClippingPicture";

let style = Object.assign({}, global);

const FrameActions = () => {
  let { metadata, updateMetadata, setIsFrameContentActive } = useContext(EditorContext);

  let { applyEditMode, revertEditMode } = useClippingPicture();

  const validActions = [
    {
      name: "Done",
      value: "SAVE",
      icon: "ui-checkmark",
      className: "frame-action-save",
      additionalclass: "mr-2",
    },
    {
      name: "Cancel",
      value: "CANCEL",
      icon: "ui-close",
      className: "frame-action-cancel",
      additionalclass: "mr-2 font-18",
    },
  ];

  const restoreActiveWidget = action => {
    let widgetId = document.getElementById("highlightImage").closest(".dhp-root-widget").getAttribute("id");

    if (action === "SAVE") applyEditMode();
    else revertEditMode();

    setIsFrameContentActive(false);
    updateMetadata({ ...metadata, activeWidgetId: [widgetId], activeWidgetType: [FRAME] });
  };

  return (
    <ul className={cx(style["toolbar-group"], style["collage"])}>
      {validActions.map((action, i) => (
        <li
          key={i}
          className={cx(style["toolset-group"], action.className)}
          onClick={() => restoreActiveWidget(action.value)}>
          <div className={style["toolset-item"]}>
            <span className={cx(style["toolset-action"], style["custom-tooltip"], "frame-action-button")}>
              <Icon icon={action.icon} additionalclass={action.additionalclass} />
              {action.name}
              <div className={cx(style["custom-tooltip-content"], style["top"])}>{action.name}</div>
            </span>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default FrameActions;
